import { PropertyActionsTypes } from '@protector/entities/property/__legacy__/redux.constants';
import { entity } from '@protector/entities/property/__legacy__/redux.reducer';
import type { PropertyState } from '@protector/entities/property/__legacy__/redux.types';
import { INITIAL_PAGE } from '@protector/utils/constants';
import type { ActionsResponses } from './property.types';

const initialState: PropertyState = entity.getInitialState({
  page: {
    ...INITIAL_PAGE
  },
  isLoadingTime: false,
  isLoading: false,
  isLoaded: false,
  isLoadedPropertyAreaInfo: false,
  error: null,
  loadingDiagnostic: false,
  propertyTime: '',
  currentAreaSeasons: [],
  seasonAreasFromActiveSeasons: {},
  isLoadedSeasonAreas: false,
  isLoadingCurrentAreaSeasons: false,
  isLoadingPropertyData: false,
  isLoadedPropertyData: false,
  propertyData: null,
  propertyPhenomenons: [],
  propertyIndicators: [],
  propertyMethodologies: [],
  isIndicatorPressureLoading: false,
  isLoadingPropertyPhenomena: false,
  seasonAreasInDate: {
    date: null,
    content: []
  }
});

export default (state = initialState, action: ActionsResponses) => {
  switch (action.type) {
    case PropertyActionsTypes.LOAD_PROPERTIES:
      return entity.removeAll({
        ...state,
        isLoading: true,
        isLoaded: false,
        isLoadedPropertyAreaInfo: false,
        propertyPhenomenons: []
      });
    case PropertyActionsTypes.LOAD_PROPERTIES_AREA_INFO:
      return {
        ...state,
        isLoadedPropertyAreaInfo: false
      };
    case PropertyActionsTypes.LOAD_PROPERTY_PHENOMENA: {
      return {
        ...state,
        isLoadingPropertyPhenomena: true,
        propertyPhenomenons: []
      };
    }
    case PropertyActionsTypes.LOAD_PROPERTY_PHENOMENA_SUCCESS: {
      return {
        ...state,
        isLoadingPropertyPhenomena: false,
        propertyPhenomenons: action.payload
      };
    }
    case PropertyActionsTypes.LOAD_SEVERITY_BY_INDICATOR: {
      return {
        ...state,
        isIndicatorPressureLoading: true
      };
    }
    case PropertyActionsTypes.LOAD_SEVERITY_BY_INDICATOR_SUCCESS: {
      return {
        ...state,
        isIndicatorPressureLoading: false
      };
    }
    case PropertyActionsTypes.LOAD_PROPERTY_INDICATORS_SUCCESS: {
      return {
        ...state,
        propertyIndicators: action.payload
      };
    }
    case PropertyActionsTypes.LOAD_PROPERTY_METHODOLOGIES_SUCCESS: {
      return {
        ...state,
        propertyMethodologies: action.payload
      };
    }
    case PropertyActionsTypes.LOAD_PROPERTIES_SUCCESS:
      return entity.addMany(action.payload.mutableContent, {
        ...state,
        page: {
          ...action.payload
        },
        isLoading: false,
        isLoaded: true,
        error: null
      });
    case PropertyActionsTypes.LOAD_PROPERTIES_FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: action.payload
      };
    case PropertyActionsTypes.LOAD_PROPERTIES_AREA_INFO_SUCCESS:
      return entity.upsertMany(action.payload.mutableContent, {
        ...state,
        page: {
          ...action.payload
        },
        isLoadedPropertyAreaInfo: true
      });

    case PropertyActionsTypes.LOAD_PROPERTY_TIME:
      return {
        ...state,
        isLoadingTime: true
      };

    case PropertyActionsTypes.LOAD_PROPERTY_TIME_SUCCESS:
      return {
        ...state,
        isLoadingTime: false,
        propertyTime: action.payload
      };
    case PropertyActionsTypes.GET_SEASON_AREAS_BY_DATE:
    case PropertyActionsTypes.GET_CURRENT_SEASON_AREAS:
      return {
        ...state,
        isLoadingCurrentAreaSeasons: true,
        isLoadedSeasonAreas: false,
        error: null
      };
    case PropertyActionsTypes.GET_SEASON_AREAS_BY_DATE_SUCCESS:
      return {
        ...state,
        seasonAreasInDate: action.payload,
        isLoadingCurrentAreaSeasons: false,
        isLoadedSeasonAreas: true,
        error: null
      };
    case PropertyActionsTypes.GET_CURRENT_SEASON_AREAS_SUCCESS:
      return {
        ...state,
        completedSeasonAreasRequest: action.payload.requestId
          ? { requestId: action.payload.requestId, error: null }
          : state.completedSeasonAreasRequest,
        currentAreaSeasons: action.payload.current,
        seasonAreasFromActiveSeasons: {
          ...state.seasonAreasFromActiveSeasons,
          [action.payload.propertyId]: action.payload.all
        },
        isLoadingCurrentAreaSeasons: false,
        isLoadedSeasonAreas: true,
        error: null
      };
    case PropertyActionsTypes.GET_CURRENT_SEASON_AREAS_FAILURE:
      return {
        ...state,
        completedSeasonAreasRequest: action.requestId
          ? { requestId: action.requestId, error: action.payload }
          : state.completedSeasonAreasRequest,
        isLoadingCurrentAreaSeasons: false,
        error: action.payload
      };
    case PropertyActionsTypes.GET_SEASON_AREAS_BY_DATE_FAILURE:
      return {
        ...state,
        isLoadingCurrentAreaSeasons: false,
        error: action.payload
      };
    case PropertyActionsTypes.LOAD_PROPERTY_DATA_SUCCESS:
      return {
        ...state,
        isLoadingPropertyData: false,
        isLoadedPropertyData: true,
        propertyData: action.payload
      };
    case PropertyActionsTypes.LOAD_PROPERTY_DATA_FAILURE:
      return {
        ...state,
        isLoadedPropertyData: false,
        isLoadingPropertyData: false,
        error: action.payload
      };
    case PropertyActionsTypes.SET_PROPERTY_BASIC_DATA_IS_LOADED:
      return {
        ...state,
        isLoadedPropertyData: action.payload
      };
    default:
      return state;
  }
};
